module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "group-statistics"
  }, [_c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.getGroupInfo($event.target.value);
        _vm.getAttendance($event.target.value)
      }
    }
  }, _vm._l((_vm.weeks), function(week) {
    return _c('option', {
      domProps: {
        "value": week
      }
    }, [_vm._v("Week " + _vm._s(week))])
  }))]), _vm._v(" "), (_vm.videos) ? _c('ul', {
    staticClass: "videos"
  }, _vm._l((_vm.videos), function(video) {
    return _c('li', [_c('h4', [_vm._v(_vm._s(_vm.getVideo(video.id).course.name) + " — " + _vm._s(video.title) + " — Week " + _vm._s(video.week))]), _vm._v(" "), _c('ul', {
      staticClass: "progresses clearfix"
    }, _vm._l((video.progresses), function(progress) {
      return _c('li', [_c('div', {
        staticClass: "col-xs-12 col-md-2 text-right nopad"
      }, [_vm._v("\n                                    " + _vm._s(progress.firstName) + " " + _vm._s(progress.lastName) + "\n                                ")]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-11 col-md-9 nopad"
      }, [_c('span', {
        staticClass: "progress",
        style: ({
          width: _vm.getProgress(progress.progress, video.totalDuration) + '%'
        })
      })])])
    })), _vm._v(" "), (video.exercise) ? _c('h5', [_vm._v("Exercise")]) : _vm._e(), _vm._v(" "), (video.exercise) ? _c('div', [_vm._v("\n                            " + _vm._s(video.exercise.title) + ": [" + _vm._s(_vm.studentHandinsCount(video.exercise.exercise_hand_ins)) + " / " + _vm._s(_vm.students.length) + "]\n\n                            "), _vm._l((video.exercise.exercise_hand_ins), function(hand_in) {
      return _c('div', {
        staticClass: "hand-in"
      }, [_c('b', [_vm._v(_vm._s(hand_in.studentName || hand_in.userId))]), _vm._v(" "), _vm._l((hand_in.url), function(file) {
        return _c('div', [_c('a', {
          attrs: {
            "href": file,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm._f("filenameFromUrl")(file)))])])
      })], 2)
    }), _vm._v(" "), _c('h6', [_vm._v("These people need help:")]), _vm._v(" "), (video.exercise.exercise_hand_ins.length > 0) ? _c('ul', {
      staticClass: "needs-help"
    }, _vm._l((_vm.helpNeeded(video.exercise.exercise_hand_ins)), function(student) {
      return _c('li', [_vm._v("\n                                    " + _vm._s(student.name) + "\n                                ")])
    })) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (video.assignments.length > 0) ? _c('div', [_c('h5', [_vm._v("Assignment: " + _vm._s(video.assignments[0]['assignment.name']) + " [" + _vm._s(video.assignments.length) + " / " + _vm._s(_vm.students.length) + "]")]), _vm._v(" "), _vm._l((video.assignments), function(hand_in) {
      return _c('div', {
        staticClass: "hand-in"
      }, [_c('b', [_vm._v(_vm._s(hand_in.studentName || hand_in.userId))]), _vm._v(" "), _vm._l((hand_in.url), function(file) {
        return _c('div', [_c('a', {
          attrs: {
            "href": file,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm._f("filenameFromUrl")(file)))])])
      })], 2)
    })], 2) : _vm._e()])
  })) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered attendance"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.attendance), function(student) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(student.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.round(student.duration / 60)) + " minutes")]), _vm._v(" "), _c('td', [(student.attentivenessScore) ? _c('span', [_vm._v(_vm._s(student.attentivenessScore.toFixed(2)) + "%")]) : _vm._e()])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('ul', {
    staticClass: "unstyled meetings"
  }, _vm._l((_vm.meetings), function(meeting) {
    return _c('li', [_c('div', [_vm._v(_vm._s(_vm._f("longDate")(meeting.startTime)))]), _vm._v(" "), (meeting.archiveStatus === 'completed') ? _c('div', [_c('a', {
      attrs: {
        "href": meeting.archiveUrl,
        "target": "_blank"
      }
    }, [_vm._v("Play Recording")]), _vm._v(" "), (meeting.secondaryRecordings && meeting.secondaryRecordings.length > 0) ? _c('span', [_vm._v("\n                            (\n                            "), _c('a', {
      attrs: {
        "href": meeting.archiveUrl,
        "target": "_blank"
      }
    }, [_vm._v("1")]), _vm._v(" "), _vm._l((meeting.secondaryRecordings), function(recording, index) {
      return _c('span', [_vm._v(",\n                                "), _c('a', {
        attrs: {
          "href": recording,
          "target": "_blank"
        }
      }, [_vm._v(" " + _vm._s(index + 2) + " ")])])
    }), _vm._v(")\n                        ")], 2) : _vm._e()]) : _c('div', [_vm._v("Recording not ready")])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Week")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Meeting Attendance")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Time in Meeting")]), _vm._v(" "), _c('th', [_vm._v("Attentiveness")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', [_vm._v("\n                Meeting Archives\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b3301870!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupStatistics.vue
// module id = 2119
// module chunks = 2